import { Col, Form, Input, Row, Select, Space } from "antd";
import { FormInput, FormSelect } from "components/form/FormProvide";
import { useTranslation } from "react-i18next";

const CompanyInfoForEdit = ({
  header = null,
  companyTypeOptions = [],
  lower = null,
}) => {
  const { t } = useTranslation();

  return (
    <Form.Item shouldUpdate={(prev, curv) => {
      return prev["companyTypeId"] !== curv["companyTypeId"]
    }}>
      {({ getFieldValue, setFieldValue }) => {
        return <Space direction="vertical" size={24} style={{ width: "100%" }}>
          {header}
          <Row gutter={[24, 16]}>
            <Col span={12}>
              {/* <Form.Item> */}
              <FormInput
                fontWeight="bold"
                vertical={true}
                required={true}
                name="companyName"
                label={
                  t("company_profile.label.company_name_th")
                }
                placeholder={t("company_profile.label.company_name_th")}
                size="large"
              />
            </Col>
            <Col span={12}>
              <FormInput
                fontWeight="bold"
                vertical={true}
                required
                name="companyNameEn"
                label={
                  t("company_profile.label.company_name_en")
                }
                placeholder={t("company_profile.label.company_name_en")}
                size="large"
              />
            </Col>
            <Col span={12}>
              <FormInput
                required
                fontWeight="bold"
                vertical={true}
                name="taxId"
                label={t("company_profile.label.tax_id")}
                placeholder={t("company_profile.label.tax_id")}
                size="large"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value.length == 13) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(''));
                    },
                  }),
                ]}
              />
            </Col>
            <Col span={12}>
              <FormSelect
                vertical={true}
                required
                fontWeight="bold"
                name="companyTypeId"
                label={t("company_profile.label.company_type")}
                placeholder="{t('company_profile.label.please_select_business_type')}"
                size="large"
                options={companyTypeOptions}
              />
            </Col>
            <Col span={12}>
              <FormInput
                fontWeight="bold"
                vertical={true}
                required
                numberOnly={true}
                name="numberOfEmployees"
                label={t("company_profile.label.number_of_employees")}
                placeholder={t("company_profile.label.number_of_employees")}
                size="large"
              />
            </Col>

            {companyTypeOptions?.find(o => o.id == getFieldValue("companyTypeId"))?.code == "COMPANY_TYPE_21" ?
              <Col span={12}>
                <FormInput
                  fontWeight="bold"
                  vertical={true}
                  required
                  name="companyTypeDesc"
                  label={t("company_profile.label.companyType_description")}
                  placeholder={t("description.please_enter_description")}
                  rows="4"
                  size="large"
                  type="textarea"
                />
              </Col>

              : null}
          </Row>
          {lower}
        </Space>
      }}
    </Form.Item>
  );
};

export default CompanyInfoForEdit;
